import { ThemeEntityType } from '../../types';

export const coalitionEntity: ThemeEntityType = {
  entityName: 'Coalition, Inc.',
  displayName: 'Coalition',
};
